import React, { useEffect, useState } from "react";
import {
  getSingleSurvey,
  addFormContent,
  updateFormContent,
  getFormContent,
  surveyResultPreview,
  sharePreviewLink,
  imageUpload,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import { Button, Snackbar } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import MuiAlert from "@mui/material/Alert";
import MySignatureCanvas from "../../molecules/signature_canvas";

const CustomerFeedback = () => {
  const { surveyId, id, flg } = useParams();

  const [formData, setFormData] = useState({
    clientName: "",
    jobType: "",
    adminResponse: "",
    crewProfessionalism: "",
    crewResponse: "",
    totalExperience: "",
    originAdmin: "",
    originCrew: "",
    recommendation: "",
    impressedEmployee: "",
    maidServices: false,
    utilities: false,
    handyman: false,
    remarks: "",
    clientSign: "",
    adminSign: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isShare, setIsShare] = useState(false);
  const [isSignCanvas, setSignCanvas] = useState(false);

  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "customer-feedback-document-preview",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Customer Feedback Form has been shared with the respective emails successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    handleOpen();

    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        // res?.data?.data?.key;

        handleClose();
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode === 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
        handleClose();
      });
  };

  return (
    <MainTemplate>
      <div className="no-print">
        <div className="no-print">
          <div className="d-block d-sm-flex align-items-center py-4">
            <div className="d-flex align-items-center ">
              <div
                className="light-blue-color back-bg cursor-pointer "
                onClick={() => navigate(-1)}
              >
                <img src={backArrow} height="24" width="24" alt="" />
              </div>
              <div>
                <p className="main-head ps-3 mb-0">Customer Feedback</p>
              </div>
            </div>
            <div className="d-flex ms-auto justify-content-center mt-2 mt-sm-0">
              {
                <Button
                  className="active-btn ms-3"
                  onClick={() => {
                    if (flg === "1") {
                    } else {
                      setIsShare(true);
                    }
                  }}
                  disabled={false}
                >
                  {flg === "1" ? "Save" : "Share"}
                </Button>
              }
            </div>
          </div>
        </div>
      </div>

      {/* Add Role Modal */}
      {isShare && (
        <ShareWithClientsModal
          open={isShare}
          onClose={() => {
            setIsShare(false);
          }}
          onSuccess={(emails) => {
            shareWithClient(emails);
          }}
        />
      )}

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* Add signature Modal */}
      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}
    </MainTemplate>
  );
};

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    clientName: "",
    jobType: "",
    adminResponse: "",
    crewProfessionalism: "",
    crewResponse: "",
    totalExperience: "",
    originAdmin: "",
    originCrew: "",
    recommendation: "",
    impressedEmployee: "",
    maidServices: false,
    utilities: false,
    handyman: false,
    remarks: "",
  });

  const RatingGroup = ({ label, name }) => (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="flex gap-4">
        {["Excellent", "Good", "Average", "Fair", "Poor"].map((option) => (
          <label key={option} className="flex items-center">
            <input
              type="radio"
              name={name}
              value={option}
              onChange={(e) =>
                setFormData({ ...formData, [name]: e.target.value })
              }
              className="h-4 w-4 text-blue-600"
              required
            />
            <span className="ml-2 text-sm">{option}</span>
          </label>
        ))}
      </div>
    </div>
  );

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <header className="text-center mb-8">
        <h2 className="text-2xl font-bold text-blue-800">SHELOZON</h2>
        <p className="text-gray-600 text-sm">
          HOVICES PACKERS AND LOGISTICS (PYT) LTD
        </p>
        <h3 className="text-xl font-semibold mt-4">CUSTOMER FEEDBACK REPORT</h3>
      </header>

      <form className="space-y-6">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Client Name
            </label>
            <input
              type="text"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              value={formData.clientName}
              onChange={(e) =>
                setFormData({ ...formData, clientName: e.target.value })
              }
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Job Type
            </label>
            <input
              type="text"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              value={formData.jobType}
              onChange={(e) =>
                setFormData({ ...formData, jobType: e.target.value })
              }
              required
            />
          </div>
        </div>

        <div className="space-y-4">
          <RatingGroup
            label="How our administration team responded to any queries"
            name="adminResponse"
          />
          <RatingGroup
            label="The professionalism of our moving crew"
            name="crewProfessionalism"
          />
          <RatingGroup
            label="How our moving crew responded to all your requirements"
            name="crewResponse"
          />
          <RatingGroup
            label="The total moving experience"
            name="totalExperience"
          />
        </div>

        <div className="grid grid-cols-2 gap-6">
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900">
              Origin Services Rating
            </h4>
            <RatingGroup
              label="Their administration process"
              name="originAdmin"
            />
            <RatingGroup label="Their moving crew" name="originCrew" />
          </div>

          <div className="space-y-4">
            <label className="block text-sm font-medium text-gray-700">
              Would you recommend SHELOZONE?
            </label>
            <select
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              value={formData.recommendation}
              onChange={(e) =>
                setFormData({ ...formData, recommendation: e.target.value })
              }
              required
            >
              <option value="">Select option</option>
              <option>Yes</option>
              <option>No</option>
              <option>Not Sure</option>
            </select>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Impressive Employees
          </label>
          <input
            type="text"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder="Name employee(s)"
            value={formData.impressedEmployee}
            onChange={(e) =>
              setFormData({ ...formData, impressedEmployee: e.target.value })
            }
          />
        </div>

        <div className="space-y-4">
          <h4 className="font-medium text-gray-900">Services Offered</h4>
          {["Maid services", "Utilities connection", "Handyman Services"].map(
            (service) => (
              <div key={service} className="flex items-center gap-4">
                <span className="text-sm w-40">{service}</span>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name={service.toLowerCase().replace(" ", "_")}
                    value="yes"
                    className="h-4 w-4 text-blue-600"
                  />
                  <span className="ml-2 text-sm">Yes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name={service.toLowerCase().replace(" ", "_")}
                    value="no"
                    className="h-4 w-4 text-blue-600"
                  />
                  <span className="ml-2 text-sm">No</span>
                </label>
              </div>
            )
          )}
        </div>

        <div className="space-y-4">
          <label className="block text-sm font-medium text-gray-700">
            Remarks
          </label>
          <textarea
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            rows={4}
            value={formData.remarks}
            onChange={(e) =>
              setFormData({ ...formData, remarks: e.target.value })
            }
          />

          <div className="flex justify-between mt-6">
            <div className="space-y-2">
              <p className="text-sm">
                Team Leader Signature:{" "}
                <span className="inline-block w-32 border-b-2 border-gray-400"></span>
              </p>
              <p className="text-sm">
                Date:{" "}
                <span className="inline-block w-32 border-b-2 border-gray-400"></span>
              </p>
            </div>
            <div>
              <p className="text-sm">
                Client Signature:{" "}
                <span className="inline-block w-32 border-b-2 border-gray-400"></span>
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button
            type="submit"
            className="bg-blue-800 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            Submit Feedback
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerFeedback;
